module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_image_annotation-d55f1dd3bdac2f3433497464dec23ddc.svg";